import {PosaRedeemStore, TrackEventObject} from '../../utils/types';
import React, {useCallback, useMemo, useState} from 'react';

import {CopyToClipboard} from 'react-copy-to-clipboard';
import {Element} from 'domhandler/lib/node';
import {localizedMessage} from '../message/Message';
import PosaTemplate from './PosaTemplate';
import PropTypes from 'prop-types';
import SuccessHeaderStyled from './SuccessHeaderStyled';
import {getSuccessData} from '../../utils';
import BonusSection from './BonusSection';
import cx from 'classnames';

export interface Props {
  resetFlow: () => void;
  trackEvent: (a: string, b: TrackEventObject) => void;
  posaRedeemStore: PosaRedeemStore;
  showBonusSection: boolean;
}

const SuccessHeader = ({resetFlow, trackEvent, posaRedeemStore, showBonusSection}: Props) => {
  const {secondaryCode: secondaryCodeObj = {}} = posaRedeemStore;
  const secondaryCode = secondaryCodeObj.code || '';
  const successData = getSuccessData(posaRedeemStore);
  const {bonusOffers} = posaRedeemStore;
  const showbonus = showBonusSection && bonusOffers && bonusOffers.length;

  const {bgImage, contentLeftColumn, contentRightColumn, disableStepsButton, visitLink, visitText} =
    successData;
  const track = useCallback(() => trackEvent('visitLink', {link: visitLink}), [visitLink]);
  const style = useMemo(
    () => ({
      backgroundImage: `url(${bgImage})`,
    }),
    [bgImage]
  );
  const [copied, setCopyStatus] = useState(false);
  const onCopy = useCallback(() => {
    trackEvent('copiedText', {});
    setCopyStatus(true);
  }, [trackEvent]);
  const options = useMemo(
    () => ({
      replace: (domnode) => {
        if (!(domnode instanceof Element && domnode.attribs)) return;
        const {attribs} = domnode as Element;
        if (!attribs) return;
        if (attribs.class === 'copyToClipboard') {
          return (
            <li className="center">
              <span className="circle">3</span>
              <CopyToClipboard text={secondaryCode} onCopy={onCopy}>
                <button className={`ecrs-button ecrs-copyToClipboard`}>
                  {localizedMessage('epic.code.redemption.posa.copyToClipboard')}
                </button>
              </CopyToClipboard>
              <span className={`ecrs-copiedText ${copied ? 'copied' : ''}`}>
                {localizedMessage('epic.code.redemption.posa.copied')}
              </span>
            </li>
          );
        }

        if (attribs.class === 'visitLink' && !disableStepsButton) {
          return (
            <li className="center">
              <span className="circle">4</span>
              <a
                className="ecrs-button"
                onClick={track}
                href={visitLink}
                target="_blank"
                rel="noopener noreferrer">
                {visitText}
              </a>
            </li>
          );
        }

        if (attribs.class === 'btn btn-primary centered restart') {
          const value = localizedMessage('epic.code.redemption.othercard');
          return (
            <button className="btn btn-primary centered" onClick={resetFlow}>
              {value}
            </button>
          );
        }
      },
    }),
    [trackEvent, resetFlow, secondaryCode, onCopy, disableStepsButton, visitLink, track, visitText]
  );

  return (
    <SuccessHeaderStyled className="ecr-success-header" style={style}>
      <div className="ecr-success-header-wrapper">
        <div className={cx('ecrs-content', {'with-bonus': showbonus})}>
          <BonusSection
            show={showBonusSection}
            bonusOffers={bonusOffers}
            header="epic.code.redemption.posa.page.redeem.confirm.reward.acquired.title"
            subtitle=""
            notice="epic.code.redemption.posa.page.redeem.confirm.reward.acquired.apply"
          />
          <PosaTemplate
            Tag="div"
            isTemplate
            className="left-part"
            string={contentLeftColumn}
            posaRedeemStore={posaRedeemStore}
          />
          <PosaTemplate
            Tag="div"
            isTemplate
            className="right-part"
            string={contentRightColumn}
            posaRedeemStore={posaRedeemStore}
            options={options}
          />
        </div>
      </div>
    </SuccessHeaderStyled>
  );
};

SuccessHeader.propTypes = {
  posaRedeemStore: PropTypes.object,
  resetFlow: PropTypes.func,
  trackEvent: PropTypes.func,
  showBonusSection: PropTypes.bool,
};

export default SuccessHeader;
